<div id="service-details-chart-container" class="service-details-chart little-box-shadow">
    <loader [size]="'medium'" *ngIf="displayLoader"></loader>
    <div id="chart-container-element" #chartContainerEle>
      <div *ngIf="!displayLoader">
        <div *ngIf="groupByProperty === 'endDate'" id="end-date-chart-text" class="chart-text">
          <h2 class="calls-count">{{this.totalCount}}</h2>
          <div *ngIf="growthDateRangeAvailable" class="growth-block">
            <span class="arrow">
              <img src="{{ this.growthPositive ? '/assets/si-green-caret.svg' : '/assets/si-red-caret.svg' }}" alt="growth-arrow-icon"/>
            </span>
            <span class="growth-value" [ngClass]="{ 'positive': growthPositive, 'negative': !growthPositive }">
              {{ this.growth | number:'1.0-0':'en-US'}}%
            </span>
          </div>

        </div>
        <div *ngIf="groupByProperty === 'accountNumber'" id="account-number-chart-text" class="chart-text chart-upper-div">
          <!-- Content here if needed -->
        </div>
        <ng-container *ngIf="groupByProperty === 'endDate'">
          <ng-container *ngIf="!isEmptyData(DateData) else NoData">
            <div id="chart-canvas-container-date" class="chart-container">
              <canvas baseChart
                id="base-chart-canvas-date"
                class="basechart-js"
                [data]="ChartData"
                [options]="ChartOptions"
                [type]="ChartType"
                (chartClick)="chartClicked($event)"
                (chartHover)="ChartHovered($event)">
              </canvas>
            </div>
          </ng-container>        
        </ng-container>
        <ng-container *ngIf="groupByProperty === 'accountNumber'">
          <ng-container *ngIf="locationsData.length > 0 else NoData">
            <div id="chart-canvas-container-location" class="chart-container">
              <canvas baseChart
                id="base-chart-canvas-location"
                class="basechart-js"
                [data]="ChartData"
                [options]="ChartOptions"
                [type]="ChartType"
                (chartClick)="chartClicked($event)"
                (chartHover)="ChartHovered($event)">
              </canvas>
            </div>
          </ng-container>
        </ng-container>
        
      </div>
    </div>
    <ng-template #NoData>
      <div id="no-data-div" class="no-data-div">No calls data available for filter selection.</div>
    </ng-template>
</div>